module.exports = __webpack_public_path__ + "static/media/translate-unselected-icon.89af53ec.png";